import { Tag } from "api/generated/cms";
import { normalizeHexColor } from "utils/themeColors";

/** A tag that has been validated at the CMS boundary: the label is known to be
 *  non-empty and the color, when present, is a usable 6-digit hex. */
export interface CmsTag {
  label: string;
  color?: string;
}

/**
 * Converts CMS tags into a shape the UI can trust: entries without a usable
 * label are dropped, and an unparseable color falls back to the issuer accent
 * rather than reaching `getContrastColor`, which assumes a 6-digit hex.
 */
export const mapCmsTags = (tags: Tag[] | undefined): CmsTag[] =>
  (tags ?? []).flatMap((tag) => {
    const label = tag.label?.trim();
    return label ? [{ label, color: normalizeHexColor(tag.color) }] : [];
  });
